export const SENTRY_ENVIRONMENT = process.env['REACT_APP_SENTRY_ENVIRONMENT'] || 'development';
export const SENTRY_RELEASE = process.env['REACT_APP_COMMIT_REF'];
export const SENTRY_IO_DSN = process.env['REACT_APP_SENTRY_IO_DSN'];
